// Only translate known business errors; never show server HTML/SQL/stack traces.
export function applicationError(error){
 const status=error?.response?.status,data=error?.response?.data;
 const code=data?.code||data?.Code||'',message=typeof data==='string'?data:data?.message||'';
 if(status===401)return {key:'appLoginRequired',action:'login'};
 if(status===403)return {key:'appForbidden'};
 if(status===429)return {key:'authTryLater'};
 if(status>=500)return {key:'appResultUnknown',action:'applications'};
 const errors={profileIncomplete:{key:'appProfileIncomplete',action:'profile'},verificationRequired:{key:'appVerificationRequired',action:'profile'},countryMissing:{key:'appCountryMissing'},jobInactive:{key:'appJobInactive'},invalidJob:{key:'appJobInactive'},alreadyApplied:{key:'applied',action:'applications',already:true},coverLetterTooLong:{key:'appLetterTooLong'}};
 if(errors[code])return errors[code];
 // Backward compatible responses from older publishes.
 if(message==='Bu ilana zaten başvuru yaptınız.')return errors.alreadyApplied;
 if(message==='İlanın ülke tanımı eksik. İK ile iletişime geçin.')return errors.countryMissing;
 if(message==='CV bulunamadı.')return errors.profileIncomplete;
 const field=data?.errors?.BasvuranAciklama??data?.errors?.basvuranAciklama;
 if(field&&JSON.stringify(field).includes('coverLetterTooLong'))return errors.coverLetterTooLong;
 return status?{key:'appFailed'}:{key:'appResultUnknown',action:'applications'};
}
export const applicationConfirmed=data=>data?.success===true||data?.message==='Başvuru başarıyla yapıldı.';
